import Div from "@jumbo/shared/Div/Div";
import { get } from "../../../common/network";
import MuiTableWrapper from "app/pages/Docgen/components/common/mui-table-wrapper/MuiTableWrapper";
import React, { useEffect, useState } from "react";
import { fetchContinuityType , fetchPriorApplicationStatus} from "app/utils/constants/fetchMappingData";
import {Date_format, formatDate} from "../../../constants/date_format";

const RelatedMattersTab = ({ id }) => {
  //#region for states
  const [selectedRows, setSelectedRows] = useState([]);
  const [data,setData] =  useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [continuityTypeMapping, setContinuityTypeMapping] = useState({});
  const [priorApplicationStatusMapping, setPriorApplicationStatusMapping] = useState({});
  const [rowsSelection,setRowsSelection] = useState([]);

  useEffect(()=>{
    const getMappings = async() =>{
      const [continuityTypeResponse, priorApplicationStatusResponse] = await Promise.all([fetchContinuityType(), fetchPriorApplicationStatus()]);
      setContinuityTypeMapping(continuityTypeResponse);
      setPriorApplicationStatusMapping(priorApplicationStatusResponse);
    }
    getMappings();
},[])

  const columns = [
    {
        field: "number",
        header: "Prior Application Number",
        sort: false,
        render: (value, row) => {
          return row?.number;
        },
    },
    {
        field: "continuityType",
        header: "Continuity Type",
        sort: false,
        render: (value, row) => {
          return continuityTypeMapping[row.continuityType] || row.continuityType;
        },
    },
    {
        field: "patentNumber",
        header: "Prio Patent Number",
        sort: false,
        render: (value, row) => {
          return row.patentNumber;
        },
    },
  
    {
        field: "status",
        header: "Prior Application Status",
        sort: false,
        render: (value, row) => {
          return priorApplicationStatusMapping[row.status] || row.status;
        },
      },
      {
        field: "filingDate",
        header: "Filing or 371c Date",
        sort: false,
        render: (value,row) => {
          if (row.filingDate) {
            return formatDate(row.filingDate, true);
          } else {
            return null;
          }
      },
    },
      
        {
          field: "issueDate",
          header: "Issue Date",
          sort: false,
          render: (value,row) => {
            if (row.issueDate) {
              return formatDate(row.issueDate, true);
            } else {
              return null;
            }
        },
      },
      {
        field: "accessCode",
        header: "Access Code",
        sort: false,
        render: (value, row) => {
          return row.accessCode;
        },
      },
    {
      field: "country",
      header: "Country",
      sort: false,
      render: (value, row) => {
        return row.country.code;
      },
    },
   
  ];

  const fetchData = async (page, rowsPerPage) => {
    setIsFetching(true);
    try {
      const response = await get(`docgen/matters/${id}`);
      setData(response?.data?.priorApplications);
    } catch (error) {
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(()=>{
    fetchData();
  },[])

  //#endregion

  return (
    <div id="related-matters-tab" name="related-matters-tab">
      <MuiTableWrapper
        columns={columns}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        hasCheckboxesColumn={false}
        
        searchValue={""}
        filterColumn={"all"}

        data={data}
        isFetching={isFetching}
        rowsSelection={rowsSelection}
        setRowsSelection={setRowsSelection}
      />
    </div>
  );
};

export default RelatedMattersTab;